export const DataNormalizer = {
  normalize(data, xAxis, yAxis) {
    if (
      !xAxis ||
      !yAxis ||
      typeof xAxis !== "string" ||
      typeof yAxis !== "string"
    ) {
      return [];
    }

    return (
      data?.map((d) => {
        const xKey = Object.keys(d).find(
          (k) =>
            k &&
            typeof k === "string" &&
            k.toLowerCase() === xAxis.toLowerCase(),
        );
        const yKey = Object.keys(d).find(
          (k) =>
            k &&
            typeof k === "string" &&
            k.toLowerCase() === yAxis.toLowerCase(),
        );
        const yValue = d[yKey];
        return {
          [xAxis]: d[xKey] ?? "",
          [yAxis]: isNaN(Number(yValue)) ? 0 : Number(yValue),
        };
      }) || []
    );
  },

  calculateTotal(data, yAxis) {
    return data.reduce((sum, d) => sum + (d[yAxis] || 0), 0);
  },

  isValidAxes(xAxis, yAxis) {
    return (
      xAxis && yAxis && typeof xAxis === "string" && typeof yAxis === "string"
    );
  },
};
